const SurveyStatus = {
  New: {
    id: "81ec52c9-caf7-407f-a027-2e4c98d07d33",
    lczKey: "lookups.survey_status.new",
    color: "#726af3"
  },
  Active: {
    id: "791e3cb4-1e78-41d4-a9fb-b45b70aa71da",
    lczKey: "lookups.survey_status.active",
    color: "#69dec4"
  },
  Completed: {
    id: "a2e702d1-6841-4308-be1e-d14048f5651f",
    lczKey: "lookups.survey_status.completed",
    color: "#fdb756"
  },
  Cancelled: {
    id: "53b18b0f-90c7-4f35-a608-d9d831567331",
    lczKey: "lookups.survey_status.cancelled",
    color: "#474554"
  }
};
const SurveyStatusArray = Object.values(SurveyStatus);
const getSurveyStatusById = (id) => SurveyStatusArray.find((s) => s.id === id);
export {
  SurveyStatus,
  SurveyStatusArray,
  getSurveyStatusById
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3VydmV5U3RhdHVzLmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL1N1cnZleVN0YXR1cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgU3VydmV5U3RhdHVzID0ge1xuXHROZXc6IHtcblx0XHRpZDogXCI4MWVjNTJjOS1jYWY3LTQwN2YtYTAyNy0yZTRjOThkMDdkMzNcIixcblx0XHRsY3pLZXk6IFwibG9va3Vwcy5zdXJ2ZXlfc3RhdHVzLm5ld1wiLFxuXHRcdGNvbG9yOiBcIiM3MjZhZjNcIixcblx0fSxcblx0QWN0aXZlOiB7XG5cdFx0aWQ6IFwiNzkxZTNjYjQtMWU3OC00MWQ0LWE5ZmItYjQ1YjcwYWE3MWRhXCIsXG5cdFx0bGN6S2V5OiBcImxvb2t1cHMuc3VydmV5X3N0YXR1cy5hY3RpdmVcIixcblx0XHRjb2xvcjogXCIjNjlkZWM0XCIsXG5cdH0sXG5cdENvbXBsZXRlZDoge1xuXHRcdGlkOiBcImEyZTcwMmQxLTY4NDEtNDMwOC1iZTFlLWQxNDA0OGY1NjUxZlwiLFxuXHRcdGxjektleTogXCJsb29rdXBzLnN1cnZleV9zdGF0dXMuY29tcGxldGVkXCIsXG5cdFx0Y29sb3I6IFwiI2ZkYjc1NlwiLFxuXHR9LFxuXHRDYW5jZWxsZWQ6IHtcblx0XHRpZDogXCI1M2IxOGIwZi05MGM3LTRmMzUtYTYwOC1kOWQ4MzE1NjczMzFcIixcblx0XHRsY3pLZXk6IFwibG9va3Vwcy5zdXJ2ZXlfc3RhdHVzLmNhbmNlbGxlZFwiLFxuXHRcdGNvbG9yOiBcIiM0NzQ1NTRcIixcblx0fSxcbn07XG5cbmV4cG9ydCBjb25zdCBTdXJ2ZXlTdGF0dXNBcnJheSA9IE9iamVjdC52YWx1ZXMoU3VydmV5U3RhdHVzKTtcblxuZXhwb3J0IGNvbnN0IGdldFN1cnZleVN0YXR1c0J5SWQgPSAoaWQpID0+XG5cdFN1cnZleVN0YXR1c0FycmF5LmZpbmQoKHMpID0+IHMuaWQgPT09IGlkKTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBWSxNQUFDLGVBQWU7QUFBQSxFQUMzQixLQUFLO0FBQUEsSUFDSixJQUFJO0FBQUEsSUFDSixRQUFRO0FBQUEsSUFDUixPQUFPO0FBQUEsRUFDUDtBQUFBLEVBQ0QsUUFBUTtBQUFBLElBQ1AsSUFBSTtBQUFBLElBQ0osUUFBUTtBQUFBLElBQ1IsT0FBTztBQUFBLEVBQ1A7QUFBQSxFQUNELFdBQVc7QUFBQSxJQUNWLElBQUk7QUFBQSxJQUNKLFFBQVE7QUFBQSxJQUNSLE9BQU87QUFBQSxFQUNQO0FBQUEsRUFDRCxXQUFXO0FBQUEsSUFDVixJQUFJO0FBQUEsSUFDSixRQUFRO0FBQUEsSUFDUixPQUFPO0FBQUEsRUFDUDtBQUNGO0FBRVksTUFBQyxvQkFBb0IsT0FBTyxPQUFPLFlBQVk7QUFFL0MsTUFBQyxzQkFBc0IsQ0FBQyxPQUNuQyxrQkFBa0IsS0FBSyxDQUFDLE1BQU0sRUFBRSxPQUFPLEVBQUU7In0=
